// import DistributionMain from './component'
import DistributionMain from './component.v2'

export default {
  path: ':id',
  element: <DistributionMain />,
}
